export const getRestaurantSettings = () => {

    const settings = localStorage.getItem(
        "restaurant_settings"
    );

    if (!settings) {

        return {
            currency: "USD",
            locale: "en-US",
            timezone: "UTC",
            currency_symbol: "$",
            country: "United States",
        };
    }

    return JSON.parse(settings);
};

export const formatCurrency = (amount) => {

    const settings = getRestaurantSettings();

    return new Intl.NumberFormat(
        settings.locale || "en-US",
        {
            style: "currency",
            currency: settings.currency || "USD",
        }
    ).format(amount || 0);
};

/**
 * Format date/time using restaurant timezone
 */
export const formatRestaurantDateTime = (
    date,
    options = {}
) => {

    if (!date) return "-";

    const settings = getRestaurantSettings();

    return new Intl.DateTimeFormat(
        settings.locale || "en-US",
        {
            timeZone: settings.timezone || "UTC",

            year: "numeric",
            month: "short",
            day: "numeric",

            hour: "numeric",
            minute: "2-digit",

            ...options,
        }
    ).format(new Date(date));
};

/**
 * Format only date
 */
export const formatRestaurantDate = (
    date,
    options = {}
) => {

    if (!date) return "-";

    const settings = getRestaurantSettings();

    return new Intl.DateTimeFormat(
        settings.locale || "en-US",
        {
            timeZone: settings.timezone || "UTC",

            year: "numeric",
            month: "short",
            day: "numeric",

            ...options,
        }
    ).format(new Date(date));
};

/**
 * Format only time
 */
export const formatRestaurantTime = (
    date,
    options = {}
) => {

    if (!date) return "-";

    const settings = getRestaurantSettings();

    return new Intl.DateTimeFormat(
        settings.locale || "en-US",
        {
            timeZone: settings.timezone || "UTC",

            hour: "numeric",
            minute: "2-digit",

            ...options,
        }
    ).format(new Date(date));
};